export default {
  contractDetail: null,
  contractDetailRestructuringDetail: null,
  contractDetailSuretyDetails: [],
  contractDetailFiles: [],
  contractDetailBorrower: null,
  contractDetailInterestRateDetails: [],
  contractDetailCallHistories: [],
  contractDetailSendSmsHistories: [],
  contractDetailSendDocHistories: [],
  contractDetailNotifications: [],
  contractDetailFeeDetails: [],
  contractDetailExpenseDetails: [],
  contractDetailPayments: [],
  contractDetailPaymentExpenses: [],
  contractDetailTransferSchedules: [],
  contractDetailPaymentRounds: [],
  contractDetailPaymentSchedules: [],
}
